import {LitElement, html, css } from 'lit-all';

class ASProductRating extends LitElement {
  static properties = {
    product: { type: Object },
  };

  constructor() {
    super() 

    this._ratingValue = this.product.metafields?.reviews?.rating?.value?.rating || 0;
    this._scaleMax = this.product.metafields?.reviews?.rating?.value?.scale_max || 5;
    this._scaleMin = this.product.metafields?.reviews?.rating?.value?.scale_min || 1;
    this._ratingCount = this.product.metafields?.reviews?.rating_count?.value || 0;
    this._ratingDecimal = 0;
    this._decimal = ratingValue % 1;

    if (this._decimal >= 0.3 && this._decimal <= 0.7) {
      this._ratingDecimal = 0.5;
    } else if (decimal > 0.7) {
      this._ratingDecimal = 1;
    }
  }

  renderFullStar() {
    return html`<span class="rating__star rating__star--full">★</span>`;
  }

  renderHalfStar() {
    return html`<span class="rating__star rating__star--half">☆</span>`; // Placeholder, replace with actual half star
  }

  renderEmptyStar() {
    return html`<span class="rating__star rating__star--empty">☆</span>`;
  }

  getAriaLabel(rating, max) {
    return `Rated ${rating} out of ${max}`;
  }

  getRatingCaption(count) {
    return `${count} reviews`;
  }

  render() {
    const stars = [];
    for (let i = this._scaleMin; i <= this._scaleMax; i++) {
      if (ratingValue >= i) {
        stars.push(this.renderFullStar());
      } else {
        if (this._ratingDecimal === 0.5) {
          stars.push(this.renderHalfStar());
          this._ratingDecimal = false; // Prevent adding more half stars
        } else if (ratingDecimal === 1) {
          stars.push(this.renderFullStar());
          this._ratingDecimal = false; // Adjust logic as per requirement
        } else {
          stars.push(this.renderEmptyStar());
        }
      }
    }

    return html`
      <div class="rating">
        <div class="rating__stars" role="img" aria-label="${this.getAriaLabel(this._ratingValue, this._scaleMax)}">
          ${stars}
        </div>
        <span class="rating__caption">${this.getRatingCaption(this._ratingCount)}</span>
      </div>
    `;
  }
}

customElements.define('as-product-rating', ASProductRating)

